import AppModalContainer from '@nxsys/components/AppModalContainer';
import { defaultLoanTypesOptions } from '@nxsys/constants/AppConstants';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import React, { useRef, useState } from 'react';
import LoanForm, { LoanFormRef, LoanFormValues } from './LoanForm';

type EditLoanProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: LoanFormValues) => Promise<void>;
  data: IBIK;
};

const EditLoanModal: React.FC<EditLoanProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditLoanProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<LoanFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: LoanFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editLoan']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <LoanForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          startDate: data.startDate,
          type:
            defaultLoanTypesOptions.find(
              (option) => option.value === data.type,
            ) || null,
          description: data.description,
          endDate: data.endDate,
          interestRate: data.interestRate?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditLoanModal;
